import { User } from './User';
import { Model } from '../common';
import * as api from '../api';

@Model('UserAuthToken')
export class UserAuthToken extends api.ApiUserAuthToken {
    get user() : User { return new User(this.getData()); }
}